var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images-wrapper"},[_c('div',{staticClass:"images",class:_vm.gridClass},_vm._l((_vm.images),function(src,index){return _c('img',{key:index,class:_vm.getCornerClass(index, _vm.images.length),attrs:{"src":_vm.fullSrc(src),"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }